import { render } from "./ArrowButton.vue?vue&type=template&id=3221b4af"
import script from "./ArrowButton.js?vue&type=script&lang=js"
export * from "./ArrowButton.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__